var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-datetimepicker',_vm._b({ref:"datePicker",attrs:{"value":_vm.value,"initial-value":_vm.initialValue,"icon":"calendar-today","required":_vm.required,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.changeDate($event)}}},'b-datetimepicker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }